// Route matching for the hash router, deliberately free of any runtime dependency (no stores, no
// ROUTES) so it can be unit-tested under Jest's node environment.

// '#/reset-password/KEY?x=1' -> '/reset-password/KEY'; '' and '#/' -> '/'
export const hashRoutePath = (hash: string): string => {
  const path = (hash || '').replace(/^#/, '').split('?')[0];
  return path.startsWith('/') ? path : `/${path}`;
};

// Exact match or a child segment. Not `startsWith` alone: '/authorized-x' must not count as covered
// by '/auth'.
export const isCoveredBy = (path: string, routePath: string): boolean =>
  path === routePath || path.startsWith(`${routePath}/`);

export const needsAuthRedirect = (
  hash: string,
  sessionFreePaths: string[]
): boolean => {
  const path = hashRoutePath(hash);
  return !sessionFreePaths.some(routePath => isCoveredBy(path, routePath));
};
